import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { useGetFlowByIntentIdMutation, useAddStepMutation, useUpdateStepMutation, useGetActiveIntentQuery } from "./Api";
import Tinymce from '../tinymce/Tinymce'

const AddSteps = ({
    mode = "add",
    onClose,
    onSave,
    data = null,
}) => {

    const [addStepApi, { isLoading }] = useAddStepMutation()
    const [updateStepApi, { isLoading: updateIsLoading }] = useUpdateStepMutation()
    const { data: activeIntents, isLoading: activeIntentsIsLoading } = useGetActiveIntentQuery()
    const [getFlowByIntentIdApi, { isLoading: getFlowIsLoading }] = useGetFlowByIntentIdMutation()

    const navigate = useNavigate()
    const [activeIntent, setActiveIntent] = useState([])
    const [activeFlows, setActiveFlow] = useState([])


    const validationSchema = Yup.object().shape({
        intant_name: Yup.string()
            .required('Intent is required')
            .trim(),
        flow_name: Yup.string()
            .required('Flow is required')
            .trim(),
        step_order: Yup.string()
            .required('Step order is required')
            .matches(/^[0-9]+$/, 'Enter valid step order')
            .trim(),
        question: Yup.string()
            .required('Question is required')
            .trim(),
        solution: Yup.string().notRequired(),
        is_final_step: Yup.string()
            .required('Is final step is required')
            .trim(),
        // resolution_text: Yup.string()
        //     .trim()
        //     .when('is_final_step', {
        //         is: (val) => val === 'yes',
        //         then: (schema) => schema.required('Resolution Text is required'),
        //         otherwise: (schema) => schema.notRequired(),
        //     }),
        status: Yup.string()
            .required('Status is required')
            .trim(),
    });

    const { register, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    const isFinalStep = watch('is_final_step');
    const isIntentSelect = watch('intant_name')

    // useEffect(() => {
    //     if (activeIntents?.data.length > 0) {
    //         setActiveIntent(activeIntents?.data)
    //     }
    // }, [activeIntents])

    // useEffect(() => {
    //     if (isIntentSelect) {
    //         getFlowByIntentId()
    //     }
    // }, [isIntentSelect])

    const firstLoad = useRef(true);

    useEffect(() => {

        if (!isIntentSelect) return;

        // Skip clearing flow on first update mode load
        if (mode === "update" && firstLoad.current) {
            firstLoad.current = false;
            getFlowByIntentId();
            return;
        }

        // clear only when user changes intent manually
        setValue("flow_name", "");
        setActiveFlow([]);

        getFlowByIntentId();

    }, [isIntentSelect]);


    useEffect(() => {
        if (data) {
            reset({
                intant_name: data.intent_id,
                flow_name: data.flow_id,
                step_order: data.step_order,
                question: data.question,
                solution: data.solution_text,
                is_final_step: data.is_final_step == 1 ? "yes" : 'no',
                // resolution_text: data.resolution_text,
                status: data.status,
            });
        }
    }, [])


    const resetButton = () => {
        reset({
            intant_name: "",
            flow_name: "",
            step_order: "",
            question: "",
            solution: "",
            is_final_step: "",
            // resolution_text: "",
            status: "",
        });
    };

    const getFlowByIntentId = async () => {
        try {
            const response = await getFlowByIntentIdApi({ intent_id: isIntentSelect })

            if (response.data.success) {
                setActiveFlow(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const onSubmit = async (payload) => {
        try {
            if (mode == 'add') {

                const values = {
                    intent_id: payload.intant_name,
                    flow_id: payload.flow_name,
                    step_order: payload.step_order,
                    question: payload.question,
                    solution_text:payload.solution,
                    is_final_step: payload.is_final_step == "yes" ? 1 : 0,
                    resolution_text:null,
                    status: payload.status,
                }

                const response = await addStepApi(values)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }
                    ToastrService.error(response.error.data.message);
                }

            } else {

                const values = {
                    intent_id: payload.intant_name,
                    flow_id: payload.flow_name,
                    step_order: payload.step_order,
                    question: payload.question,
                    solution_text:payload.solution,
                    is_final_step: payload.is_final_step == "yes" ? 1 : 0,
                    resolution_text: payload.resolution_text || null,
                    status: payload.status,
                    id: data.id
                }

                const response = await updateStepApi(values)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }
                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading || activeIntentsIsLoading || getFlowIsLoading ? <Loader /> :
                <>
                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">

                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Create New Step" : "Manage Step"}
                                </h3>
                                <small className="text-muted">{mode === "add" ? "Fill in the details below to create a KB Step." : "Update the details below to Manage KB Step"}</small>
                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>

                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Intent <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="intant_name"
                                        name="intant_name"
                                        {...register('intant_name')}
                                        className="custom-select"
                                    >
                                        <option value="">Select Intent</option>
                                        {activeIntents?.data?.length > 0 &&
                                            activeIntents?.data.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.intent_name}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.intant_name && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.intant_name.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Flow <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="flow_name"
                                        name="flow_name"
                                        {...register('flow_name')}
                                        className="custom-select"
                                        disabled={!isIntentSelect}
                                    >
                                        <option value=""> {isIntentSelect ? "Select Flow" : "Select an Intent first"}</option>
                                        {activeFlows?.length > 0 &&
                                            activeFlows?.map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.flow_name}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.flow_name && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.flow_name.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Question <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="question"
                                        name='question'
                                        placeholder='Enter the question'
                                        {...register('question')}
                                        className="form-control"

                                    />
                                    {errors.question && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.question.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Step Order <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="step_order"
                                        name='step_order'
                                        placeholder='Enter the step order'
                                        {...register('step_order')}
                                        className="form-control"

                                    />
                                    {errors.step_order && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.step_order.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Solution
                                    </label>

                                    <Tinymce
                                        id="solution"
                                        value={watch("solution") || ""}
                                        onEditorChange={(content) => setValue("solution", content)}
                                    />

                                    {errors.solution && (
                                        <p
                                            className="mt-2"
                                            style={{
                                                color: "#d93025",
                                                fontFamily: "revert",
                                                marginLeft: "1%",
                                            }}
                                        >
                                            {errors.solution.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3 final-step-radio-group">
                                    <label className="form-label">
                                        Is Final Step <span className="text-danger">*</span>
                                    </label>

                                    <div className="d-flex gap-4 align-items-center">

                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id="final_no"
                                                value="no"
                                                {...register("is_final_step")}
                                            />
                                            <label className="form-check-label small" htmlFor="final_no">
                                                No
                                            </label>
                                        </div>

                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id="final_yes"
                                                value="yes"
                                                {...register("is_final_step")}
                                            />
                                            <label className="form-check-label small" htmlFor="final_yes">
                                                Yes
                                            </label>
                                        </div>

                                    </div>
                                    {errors.is_final_step && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.is_final_step.message}
                                        </p>
                                    )}
                                </div>


                                {/* {isFinalStep === 'yes' && (
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Resolution Text <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="resolution_text"
                                            name='resolution_text'
                                            placeholder='Enter the Intent name'
                                            {...register('resolution_text')}
                                            className="form-control"

                                        />
                                        {errors.resolution_text && (
                                            <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                                {errors.resolution_text.message}
                                            </p>
                                        )}
                                    </div>
                                )} */}

                                <div className="mb-3">
                                    <label className="form-label">
                                        Status <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="status"
                                        name="status"
                                        {...register('status')}
                                        className="custom-select"
                                    >
                                        <option value="">Select status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    {errors.status && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.status.message}
                                        </p>
                                    )}

                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Create step" : "Update step"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>

                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default AddSteps;